export default __webpack_public_path__ + "static/media/team4.159dd228.png";